module.exports = __webpack_public_path__ + "static/media/Mobile_Data_AGILIDADE_DEVOPS_E_PERFORMANCE_EM_TI-13.d91f9d4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/agilidade/Mobile_Data_AGILIDADE_DEVOPS_E_PERFORMANCE_EM_TI-13.png
// module id = 73
// module chunks = 0